import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { Store } from '@ngxs/store';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Severity } from 'src/app/global/enums/severity';
import { LicenseStudyAreaServiceService } from 'src/app/predictor/services/license-study-area-service.service';
import { NotificationsActions } from 'src/app/state/notifications/notifications.actions';

@Component({

  selector: 'app-add-study-area-name-modal',
  templateUrl: './add-study-area-name-modal.component.html',
  styleUrl: './add-study-area-name-modal.component.scss'
})
export class AddStudyAreaNameModalComponent implements OnInit {
  public estimatedCost = 0;
  public estimatedAcre = 0;
  public remainingLicenseArea: string = '1500';
  //public remainingLicenseAreaUnit = 'square-kilometers';
  public currentStudyArea: string = '0';
  public areaUnit = '';

  public studyAreaName: string = '';
  public licenseNumber: string = '';

  form: FormGroup;
  model: any = {};
  options: FormlyFormOptions = {};


  studyAreaNameFields: FormlyFieldConfig[] = [];
  constructor(private fb: FormBuilder, public ref: DynamicDialogRef,
    private studyAreaService: LicenseStudyAreaServiceService
    , public config: DynamicDialogConfig, private readonly store: Store
  ) {
    this.form = this.fb.group({});
  }

  ngOnInit(): void {
    this.initializeFields();
    const { remainingLicenseArea, currentStudyArea, areaUnit, licenseNumber } = this.config.data;
    console.log('Remaining License Area:', remainingLicenseArea, 'Area Unit:', areaUnit, 'currentStudyArea:', currentStudyArea, 'currentStudyAreaUnit:', areaUnit);
    this.remainingLicenseArea =  remainingLicenseArea != null
    ? new Intl.NumberFormat().format(remainingLicenseArea)
    : '0';
    this.areaUnit = areaUnit;

    this.currentStudyArea = currentStudyArea != null ? new Intl.NumberFormat().format(currentStudyArea): '0';
    this.licenseNumber = licenseNumber;
  }

  initializeFields(): void {
    this.studyAreaNameFields = [
      {
        fieldGroupClassName: 'p-fluid p-formgrid p-grid',
        fieldGroup: [
          {
            className: 'basin-width-100',
            key: 'studyAreaName',
            type: 'input',
            templateOptions: {
              label: 'Study Area Name',
              required: true,
              placeholder: 'Study Area Name',
              maxLength: 255,
            },
            validation: {
              messages: {
                maxlength: 'Maximum 255 characters'
              },

            },
          }
        ]
      }
    ];
  }

  onContinue(): void {
    if (this.form.valid) {
      const studyAreaName = this.model.studyAreaName;

      this.studyAreaService.isUniqueStudyAreaNameForGivenLicense(studyAreaName, this.licenseNumber)
        .subscribe(isNameExist => {
          if (isNameExist) {
            this.handleNameExists();
          } else {
            this.handleNameDoesNotExist(studyAreaName);
          }
        });
    } else {
      this.form.markAllAsTouched();
    }
  }

  private handleNameExists(): void {
    this.store.dispatch(new NotificationsActions.Toast(
      'Use another study area name, it is already in use.',
      Severity.Error
    ));
  }

  private handleNameDoesNotExist(studyAreaName: string): void {
    this.studyAreaService.setStudyAreaName(studyAreaName);
    this.ref.close(this.form.value);
    this.studyAreaService.setStep(1);
  }

  onCancel(): void {
    this.ref.close();
  }

}

